import request from '../common/request';

// 部门列表
export const appointmentdept = () => request({
  url: '/api/appointmentdept/list',
  method: 'get',
});

// 事项列表
export const appointmentmatter = (params) => request({
  url: '/api/appointmentmatter/list',
  method: 'get',
  params:{
    ...params
  }
});

// 获取今日起到未来七个工作日
export const getSevenWorkDaysAfterToday = () => request({
  url: '/api/blade-attendance/attendancecalendar/getSevenWorkDaysAfterToday',
  method: 'get',
});

// 事项列表
export const getCanAppointmentTime = (params) => request({
  url: '/api/appointmentrule/getCanAppointmentTime',
  method: 'get',
  params:{
    ...params
  }
});

// 预约
export const appointmentmatterrecord = (params) => request({
  url: '/api/appointmentmatterrecord',
  method: 'post',
  data:{
    ...params
  }
});

//预约列表  
export const getList = (params) => request({
  url: '/api/appointmentmatterrecord/custom-page',
  method: 'get',
  params:{
    ...params
  }
});

//预约详情
export const getDetail = (id) => {
  return request({
    url: '/api/appointmentmatterrecord/' + id,
    method: 'get'
  })
}

//预约修改 
export const update = (row) => {
  return request({
    url: '/api/appointmentmatterrecord/' + row.id,
    method: 'put',
    data: row
  })
}

// 获取字典
export const getDictionary = (code) => request({
  url: '/api/blade-system/dict/dictionary',
  method: 'get',
  params:{
    code
  }
});